<template>
  <section>
    <p v-if="message" class="text-static-default-hi body-1 p-8">
      {{ message }}
    </p>
    <Carousel
      :card-classes="tw`w-[200px]`"
      :region-label="i18n(translations.regionLabel)"
    >
      <RevButtonCard
        v-for="card in cards"
        :key="card.id || card.label"
        class="overflow-hidden flex flex-col h-full w-full"
        @click="handleCardClick(card)"
      >
        <RevIllustration
          class="!h-[125px] object-cover w-full"
          alt=""
          :src="
            card.image_url ||
            toPublicPath(`/img/shopping-assistant/gifting/${card.id}.jpg`)
          "
          :height="125"
          :width="200"
        />
        <h3
          class="body-1-bold text-static-default-hi p-16 text-left !leading-none"
        >
          {{ card.label }}
        </h3>
      </RevButtonCard>
    </Carousel>
  </section>
</template>

<script setup lang="ts">
import { toPublicPath } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonCard } from '@ds/components/ButtonCard'
import { RevIllustration } from '@ds/components/Illustration'
import { tw } from '@ds/utils/tailwind'

import type { GiftCard } from '~/api/shopping-assistant/types'

import Carousel from '../Carousel/Carousel.vue'

import translations from './GiftingCardCarousel.translations'

defineProps<{ message?: string; cards: GiftCard[] }>()
const emits = defineEmits<{ click: [label: string] }>()

const i18n = useI18n()

const tracking = useTracking()

function handleCardClick(card: GiftCard) {
  tracking.trackClick({
    zone: 'ai_shopping_assistant_gift_cards',
    card_id: card.id,
  })
  emits('click', card.label)
}
</script>
